export default __webpack_public_path__ + "static/media/plate.8fb36a25.png";